/**
 * RecurringInvoices API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createRecurringInvoice,
  deleteRecurringInvoice,
  getRecurringInvoiceById,
  getRecurringInvoices,
  pauseRecurringInvoice,
  permanentDeleteRecurringInvoice,
  restoreRecurringInvoice,
  resumeRecurringInvoice,
  triggerRecurringInvoice,
  updateRecurringInvoice,
} from "../generated/recurring-invoices/recurring-invoices";

import { wrapListMethod, wrapMethod } from "./utils";

export const recurringInvoices = {
  /** @see createRecurringInvoice */
  create: wrapMethod(createRecurringInvoice),

  /** @see getRecurringInvoices */
  list: wrapListMethod(getRecurringInvoices),

  /** @see getRecurringInvoiceById */
  get: wrapMethod(getRecurringInvoiceById),

  /** @see updateRecurringInvoice */
  update: wrapMethod(updateRecurringInvoice),

  /** @see deleteRecurringInvoice */
  delete: wrapMethod(deleteRecurringInvoice),

  /** @see restoreRecurringInvoice */
  restoreRecurringInvoice: wrapMethod(restoreRecurringInvoice),

  /** @see permanentDeleteRecurringInvoice */
  permanentDeleteRecurringInvoice: wrapMethod(permanentDeleteRecurringInvoice),

  /** @see pauseRecurringInvoice */
  pauseRecurringInvoice: wrapMethod(pauseRecurringInvoice),

  /** @see resumeRecurringInvoice */
  resumeRecurringInvoice: wrapMethod(resumeRecurringInvoice),

  /** @see triggerRecurringInvoice */
  triggerRecurringInvoice: wrapMethod(triggerRecurringInvoice),
} as const;

export type RecurringInvoicesApi = typeof recurringInvoices;
